"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobTypes = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const base_job_types_1 = require("./base-job-types");
const service_view_1 = require("./service-view");
let JobTypes = class JobTypes extends base_job_types_1.BaseJobTypes {
};
JobTypes = __decorate([
    data_ui_1.DataUi.Permissions(contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER),
    data_ui_1.DataUi.Name({
        name: 'Job Types',
        nameProperties: ['jobApiId'],
    }),
    (0, typeorm_1.ViewEntity)({
        dependsOn: [service_view_1.ServiceView],
        expression: `
      SELECT -- version 8
      job_api_id,
      ((service_types && ARRAY['170.Material_und_Arbeit', '020.Installation']) AND NOT (service_types && ARRAY['230.Meter_application', '240.Installation_preparation', '250.Present_counter_installation'])) installation,
      (service_types <@  ARRAY['030.Planning', '160.Remote_Validation'] AND NOT service_types && ARRAY['230.Meter_application', '240.Installation_preparation', '250.Present_counter_installation'] and cardinality(service_types) > 0)  precheck,
      (service_types <@  ARRAY['200.Activation'] AND NOT service_types && ARRAY['230.Meter_application', '240.Installation_preparation', '250.Present_counter_installation'] and cardinality(service_types) > 0) activation,
      (
        (products_count > 0 AND services_count = 0)
        OR (products_count = 0 AND service_types <@ ARRAY['110.Delivery', '090.Material_costs', '090.Materialkosten'])
        OR (products_count > 0 AND service_types <@ ARRAY['110.Delivery', '090.Material_costs', '090.Materialkosten'])
      ) hardware_sale,
      (service_types <@ ARRAY['220.Maintenance'] and cardinality(service_types) > 0) maintenance,
      (service_types <@ ARRAY['260.Defect_elimination'] and cardinality(service_types) > 0) defect_elimination,
      (service_types && ARRAY['230.Meter_application'] and cardinality(service_types) > 0) meter_application,
      (service_types && ARRAY['240.Installation_preparation'] and cardinality(service_types) > 0) installation_preparation,
      remote,
      planning,
      customer_sign_required,
      async_appointment,
      reclamation
    FROM (
      SELECT
        j.api_id__c job_api_id,
        -- j.name as job_name,
        COUNT(js) + COUNT(cs) services_count,
        COUNT(jp) products_count,
        ARRAY_CAT(
          COALESCE(array_agg(
            DISTINCT s.planning_service__c::text
          ) FILTER (
            WHERE
            s.planning_service__c::text NOT IN ('010.Anfahrt', '130.Kommission', '040.Mehrarbeit', '900.Prepayment', '901.DeductionOfPrepayment', '080.Preisreduktion', '200.Package')
          ), ARRAY[]::text[]),
          COALESCE(array_agg(
            DISTINCT cs.service_type::text
          ) FILTER (
            WHERE
            cs.service_type::text NOT IN ('010.Anfahrt', '130.Kommission', '040.Mehrarbeit', '900.Prepayment', '901.DeductionOfPrepayment', '080.Preisreduktion', '200.Package')
          ), ARRAY[]::text[])
        ) as service_types,
        COALESCE(
          BOOL_AND(s.is_remote__c)
          FILTER (
            WHERE
            s.planning_service__c::text NOT IN ('130.Kommission', '040.Mehrarbeit', '900.Prepayment', '901.DeductionOfPrepayment', '080.Preisreduktion', '200.Package')
          ), FALSE) remote,
        COALESCE(BOOL_AND(s.is_planning__c), FALSE) planning,
        COALESCE(BOOL_OR(s.is_customer_sign_required__c), FALSE) customer_sign_required,
        COALESCE(BOOL_AND(s.async_appointment__c), FALSE) async_appointment,
        COALESCE(BOOL_AND(j.is_reclamation), FALSE) reclamation
      FROM
        public.job__c j
      LEFT JOIN
        public.job_service__c js
        ON (js.job_id = j.api_id__c AND js.is_active__c)
      LEFT JOIN
        public.service s
        ON (s.sfid = js.service__c AND s.opportunity__c = j.opportunity__c)
      LEFT JOIN
        public.job_product jp
        ON (jp.job_api_id = j.api_id__c)
      LEFT JOIN
        public.custom_service cs
        ON (cs.job_api_id = j.api_id__c)
      GROUP BY
        j.api_id__c
    ) jt
  `,
    })
], JobTypes);
exports.JobTypes = JobTypes;
//# sourceMappingURL=job-types.js.map